import { TemplateRef, Component, ContentChildren, QueryList, ViewChildren, ViewChild, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DOCUMENT } from '@angular/common';
// Services.
import { ToastService } from '@services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { QWebPrinterService } from '@services/qwebprinter.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ApiServerService } from '@services/api-server.service';
import { QsignerService } from '@services/qsigner.service';

// Para las traducciones.
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale, ptBrLocale, enGbLocale } from 'ngx-bootstrap/locale';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

// Components
import { PdfViewerComponent } from 'ng2-pdf-viewer';

// Entorno.
import { environment } from '@environments/environment';

// Helpers
import { scrollToTop, obtainApi, setToken, obtainTokenAndCompanyParamsSigner, showToaster, manageAES } from '@helpers';
// import { window } from 'rxjs';

// Establecer lenguaje.
defineLocale('es', esLocale);

declare global {
  interface Window {
    nsWebViewInterface?: any;
  }
}

@Component({
  selector: 'qsignerhome',
  templateUrl: './qWebPrinter.component.html',
  styleUrls: ['./qWebPrinter.component.scss'],
})
export class QWebPrinterComponent implements OnInit {
  public oLangWebViewInterface = window['nsWebViewInterface'];
  // Lista de parametros.
  public urlParams: any;

  // Parametros posibles en la ruta
  private id: any;
  private idCliente: any;
  private idIdioma: any;
  public qbrowser: any;
  public category;
  public user: any;

  // Para los service params.
  public sp: any;

  // Listado de documentos inicial.
  public documentos: any;
  public documents: any;
  public document: any;

  // Numero de documento actual.
  public currentDocument: number;

  // Bandera: Para mostrar la lista de documentos.
  public showDocumentList: boolean;

  // Bandera: Para mostrar los documentos Pdf.
  public showDocumentPdf: boolean;

  // Bandera: Para mostrar la pantalla final con la posible descarga de los documentos firmados.
  public showDownloadScreen: boolean;

  // Bandera: Para mostrar los datos.
  public showData: boolean;

  // Para el loading principal.
  public loadingData: boolean;

  // Para el loading de documento.
  public loadingDocument: boolean;

  // Para el boton de imprimir.
  private documentPrint: any;

  // Bandera: Para saber si hay banners o no.
  public hasBanners;

  // Listado de banners inicial.
  public bannerList: any;

  // Lenguaje.
  public locale: any;

  // PDF params
  public page: number;
  public totalPages: number;
  public isLoaded: boolean;
  public zoom: number;
  public datepicker: any;
  public modalRef: BsModalRef | undefined;
  public message: string | undefined;

  // Bandera: Si tiene documento pdf.
  public hasDocument: boolean | undefined;

  // URL.
  private url: string = environment.url;

  // Para las firmas.
  public idsSignature: any;
  public ids: any;

  public idsButtons: any;
  public model: any;
  public modelo: any;

  // Ruta al pdf.
  public pdfSrc: any;
  public loopNum: any;

  // Documentos seleccionados.
  public checkedDocuments: any;

  public nativo;
  public sizeSign: number = 3000;
  // Existentes
  public blockBody: boolean | undefined;
  public hideElements: boolean;
  public loadingDataWebPrinter: boolean;
  public sendingData: boolean | undefined;
  public showNextButton: boolean;

  public totalDocuments: number;
  public idDocumento: any;
  public documentToPrint: any;
  public elementToPrint: string;
  public loadingDownloadSingDocument: boolean;

  // Childs.
  @ContentChildren(QWebPrinterComponent)
  public form!: QueryList<QWebPrinterComponent>;
  @ViewChildren('signature')
  public firmas!: QueryList<any>;
  @ViewChildren('tab')
  public tab!: QueryList<QWebPrinterComponent>;
  @ViewChildren('info')
  public info!: QueryList<QWebPrinterComponent>;
  @ViewChild('template')
  public template!: TemplateRef<any>;
  @ViewChild('pdfViewer')
  pdfViewer!: PdfViewerComponent;

  documentosToDownload: any[] = [];
  notDownloadDocument: boolean = false;

  // Traducciones
  public getting_information_label: string = '';
  public error_get_data_label: string = '';
  public error_get_document_label: string = '';
  public require_fields_label: string = '';
  public error_client_label: string = '';
  public send_data_label: string = '';
  public printed_label: string = '';
  public signed_label: string = '';
  public it_has_a_total_of_label: string = '';
  public pages_to_review_label: string = '';
  public sing_title_label: string = '';
  public without_title_label: string = '';
  public mandatory_fields_label: string = '';
  public yes_label: string = '';
  public no_label: string = '';
  public answer_label: string = '';
  public selected_options_label: string = '';
  public finish_successfully_label: string = '';
  public choose_download_document_label: string = '';
  public download_label: string = '';
  public downloading_label: string = '';
  public finish_label: string = '';
  public available_documents_label: string = '';
  public available_documents_description_label: string = '';
  public continue_label: string = '';
  public document_label: string = '';
  public loadingSendDocuments: boolean = false;

  typeRequiredError: string = '';
  require_require_max_size_sing_label: any;
  event: any;

  // Configuración inicial y traducciones.
  constructor(
    @Inject(DOCUMENT) private documentDOM: Document,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private translateService: TranslateService,
    public localeService: BsLocaleService,
    public qwebprinterService: QWebPrinterService,
    public apiServerService: ApiServerService,
    public qsignerService: QsignerService,
    public storage: LocalStorageService
  ) {
    // Establecer valores iniciales por defecto.
    this.urlParams = [];
    this.sp = {};
    this.documentos = {};
    this.currentDocument = 0;
    this.showDocumentList = false;
    this.showDocumentPdf = false;
    this.showData = false;
    this.showDownloadScreen = false;
    this.loadingData = true;
    this.loadingDocument = false;
    this.category = 1;
    this.hideElements = false;
    this.page = 1;
    this.totalPages = 0;
    this.idsSignature = [];
    this.idsButtons = [];
    this.model = {};
    this.modelo = {};
    this.loadingDataWebPrinter = false;
    this.nativo = false;
    this.showNextButton = false;
    this.isLoaded = false;
    this.zoom = 1;
    this.hasBanners = false;
    this.totalDocuments = 0;
    this.documentToPrint = {};
    this.elementToPrint = '';
    this.loadingDownloadSingDocument = false;
    // Comprobar si es nativo o no.
    this.oLangWebViewInterface.on('checkIsNative', () => {
      this.nativo = true;
    });
    // Cargar las traduciones.
    this.translates();
  }

  // Se obtienen los parametros de la url y se consultan los documentos correspondientes.
  public ngOnInit(): void {
    // Obtener parámetros de la url.
    this.activatedRoute.queryParams.subscribe((params) => {
      this.urlParams = Object.keys(params);
      for (var i = 0; i < this.urlParams.length; i++) {
        switch (this.urlParams[i]) {
          case 'id':
            this.id = params[this.urlParams[i]];
            break;
          case 'eid':
            this.id = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'idCliente':
            this.idCliente = params[this.urlParams[i]];
            break;
          case 'eidCliente':
            this.idCliente = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'idIdioma':
            this.idIdioma = params[this.urlParams[i]];
            break;
          case 'eidIdioma':
            this.idIdioma = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'qbrowser':
            this.qbrowser = params[this.urlParams[i]];
            break;
          case 'eqbrowser':
            this.qbrowser = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'category':
            this.category = params[this.urlParams[i]];
            break;
          case 'ecategory':
            this.category = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'user':
            this.user = params[this.urlParams[i]];
            break;
          case 'euser':
            this.user = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'event':
            this.event = params[this.urlParams[i]];
            break;
          case 'eevent':
            this.event = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
        }
      }
      // Comprobar datos obligatorios.
      if ((!this.id && !this.idCliente && this.category && this.user) || !this.idIdioma) {
        showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', this.require_fields_label);
      } else {
        // Determinar idioma.
        if (this.idIdioma) {
          switch (this.idIdioma) {
            case 'es':
              this.locale = esLocale;
              this.idIdioma = 'es';
              break;
            case 'pt':
              this.locale = ptBrLocale;
              this.idIdioma = 'pt';
              break;
            case 'en':
              this.locale = enGbLocale;
              this.idIdioma = 'en';
              break;
            default:
              this.locale = esLocale;
              this.idIdioma = 'es';
              break;
          }
          defineLocale(this.idIdioma, this.locale);
          this.localeService.use(this.idIdioma);
        }
        // Obtener api.
        obtainApi(this.qwebprinterService, this.url, this.toastService).then((api: any) => {
          obtainTokenAndCompanyParamsSigner(api, this.storage, this.qwebprinterService, this.toastService, this.apiServerService, this.url, this.idCliente).then(
            (serviceParams: any) => {
              // Com probar si tiene o no tiene acceso a la api.
              if (serviceParams === 'NO_CLIENT') {
                showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', this.error_client_label);
                this.loadingData = false;
                this.showDocumentList = true;
              } else {
                // Coger los datos de la api.
                this.sp = serviceParams;
                // Obtener los documentos.
                this.obtainDocumentsList(serviceParams['token'], serviceParams['companyParams']);
                // Get banners from OR ref (id)
                this.getBanners(this.id);
              }
            }
          );
        });
      }
    });
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.setDynamicSize();
      }, 500);
    });
  }

  public ngAfterViewInit(): void {
    this.oLangWebViewInterface.emit('checkIsNative', true);
  }

  // Cargar las traduciones.
  public translates() {
    this.translateService.get('GETTING_INFORMATION').subscribe((value) => {
      this.getting_information_label = value;
    });
    this.translateService.get('COMMON.ERROR_GET_DATA').subscribe((value) => {
      this.error_get_data_label = value;
    });
    this.translateService.get('COMMON.ERROR_GET_DOCUMENT').subscribe((value) => {
      this.error_get_document_label = value;
    });
    this.translateService.get('REQUIRE_FIELDS').subscribe((value) => {
      this.require_fields_label = value;
    });
    this.translateService.get('REQUIRE_MAX_SIZE_SING').subscribe((value) => {
      this.require_require_max_size_sing_label = value;
    });
    this.translateService.get('COMMON.ERROR_CLIENT').subscribe((value) => {
      this.error_client_label = value;
    });
    this.translateService.get('SEND_DATA').subscribe((value) => {
      this.send_data_label = value;
    });
    this.translateService.get('PRINTED').subscribe((value) => {
      this.printed_label = value;
    });
    this.translateService.get('SIGNED').subscribe((value) => {
      this.signed_label = value;
    });
    this.translateService.get('IT_HAS_A_TOTAL_OF').subscribe((value) => {
      this.it_has_a_total_of_label = value;
    });
    this.translateService.get('PAGES_TO_REVIEW').subscribe((value) => {
      this.pages_to_review_label = value;
    });
    this.translateService.get('SIGN_TITLE').subscribe((value) => {
      this.sing_title_label = value;
    });
    this.translateService.get('SIGNER.WITHOUT_TITLE').subscribe((value) => {
      this.without_title_label = value;
    });
    this.translateService.get('MANDATORY_FIELDS').subscribe((value) => {
      this.mandatory_fields_label = value;
    });
    this.translateService.get('SIGNER.YES').subscribe((value) => {
      this.yes_label = value;
    });
    this.translateService.get('SIGNER.NO').subscribe((value) => {
      this.no_label = value;
    });
    this.translateService.get('CLEAN_ANSWER').subscribe((value) => {
      this.answer_label = value;
    });
    this.translateService.get('SIGNER.SELECT_OPTION').subscribe((value) => {
      this.selected_options_label = value;
    });
    this.translateService.get('FINISH_SUCCESSFULLY').subscribe((value) => {
      this.finish_successfully_label = value;
    });
    this.translateService.get('CHOOSE_DOWNLOAD_DOCUMENT').subscribe((value) => {
      this.choose_download_document_label = value;
    });
    this.translateService.get('DOWNLOAD').subscribe((value) => {
      this.download_label = value;
    });
    this.translateService.get('DOWNLOADING').subscribe((value) => {
      this.downloading_label = value;
    });
    this.translateService.get('FINISH').subscribe((value) => {
      this.finish_label = value;
    });
    this.translateService.get('AVAILABLE_DOCUMENTS').subscribe((value) => {
      this.available_documents_label = value;
    });
    this.translateService.get('AVAILABLE_DOCUMENTS_DESCRIPTION').subscribe((value) => {
      this.available_documents_description_label = value;
    });
    this.translateService.get('CONTINUE').subscribe((value) => {
      this.continue_label = value;
    });
    this.translateService.get('COMMON.DOCUMENT').subscribe((value) => {
      this.document_label = value;
    });
  }

  /**
   * Obtiene la lista de documentos disponibles desde el servidor.
   *
   * OPTIMIZACIÓN: Si detecta un solo documento sin firmas ni autorizaciones,
   * delega a obtainDocumentsListWithContent() para obtener el contenido completo
   * y optimizar el flujo.
   *
   * Para múltiples documentos o documentos con firmas, mantiene el flujo original
   * sin descargar el contenido del documento (returnDocument: 'false').
   *
   * @param token - Token de autenticación
   * @param apiServer - Parámetros del servidor API
   * @private
   */
  private obtainDocumentsList(token: any, apiServer: any): void {
    // Crear objeto de consulta.
    let objConsulta = {
      documento: {
        reference: this.id,
        returnDocument: 'false', // Por defecto false, se cambiará después si es necesario
        event: this.event,
      },
      companyParams: apiServer,
      token: false,
    };
    // Petición para obtener los documentos.
    this.qwebprinterService.getDocuments(this.url, objConsulta).subscribe((datos: any) => {
      // Deshabilitar impresión.
      this.documentPrint = undefined;
      // Comprobar si hay datos y setear el token.
      if (datos && datos.tokenObj && datos.api) {
        setToken(datos.api, datos.tokenObj, this.storage);
      }
      // Comprobar si hay documentos.
      if (!datos.documents) {
        // Mensaje para el usuario.
        showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', this.error_get_data_label);
      } else {
        // Limpiar los datos e incluir solo los que tengan la propiedad documents.
        var cleanedDocuments = [];
        for (var i = 0; i < datos.documents.length; i++) {
          if (datos.documents[i] !== '') {
            cleanedDocuments.push(datos.documents[i]);
          }
        }

        // OPTIMIZACIÓN: Si es un solo documento sin firmas, hacer otra llamada con el documento completo
        if (cleanedDocuments.length === 1 && this.isDocumentWithoutSignatures(cleanedDocuments[0])) {
          this.obtainDocumentsListWithContent(token, apiServer);
          return;
        }

        // Cargar los documentos en la varible principal.
        this.documentos = { documents: cleanedDocuments };

        // OPTIMIZACIÓN: Si solo hay un documento CON firmas, auto-seleccionarlo y avanzar directamente al paso de firma
        if (cleanedDocuments.length === 1 && !this.isDocumentWithoutSignatures(cleanedDocuments[0])) {
          // Auto-seleccionar el único documento
          this.modelo['file-' + cleanedDocuments[0].documentId] = true;
          this.modelo['file-data'] = true;
          this.checkedDocuments = true;

          // Avanzar automáticamente al paso de firma
          this.obtenerInfo();
        } else if (cleanedDocuments.length > 1) {
          // Quitar loading principal.
          this.loadingData = false;
          // Mostrar la lista de documentos si hay más de uno
          this.showDocumentList = true;
          // Establecer inicialmente todos los documentos como desmarcados.
          this.checkedDocuments = false;
        }
      }
    });
  }

  /*
    BANNERS.
  */

  /**
   * Verifica si un documento no tiene firmas ni autorizaciones.
   *
   * Comprueba que tanto signatureId como authorizationId estén vacíos o no existan.
   * Este método se utiliza para determinar si se puede aplicar el flujo optimizado.
   *
   * @param document - Documento a verificar
   * @returns true si el documento no tiene firmas ni autorizaciones, false en caso contrario
   * @private
   */
  private isDocumentWithoutSignatures(document: any): boolean {
    return (!document.signatureId || document.signatureId === '') && (!document.authorizationId || document.authorizationId === '');
  }

  /**
   * Obtiene la lista de documentos con el contenido completo incluido.
   *
   * Este método se ejecuta Únicamente en el caso optimizado: cuando hay un solo documento
   * sin firmas ni autorizaciones. Realiza una petición con returnDocument: 'true' para
   * obtener el contenido del PDF y evitar peticiones adicionales posteriores.
   *
   * Después de obtener el documento, auto-selecciona el documento y avanza automáticamente
   * al siguiente paso del flujo.
   *
   * @param token - Token de autenticación
   * @param apiServer - Parámetros del servidor API
   * @private
   */
  private obtainDocumentsListWithContent(token: any, apiServer: any): void {
    let objConsulta = {
      documento: {
        reference: this.id,
        returnDocument: 'true',
        event: this.event,
      },
      companyParams: apiServer,
      token: false,
    };

    this.qwebprinterService.getDocuments(this.url, objConsulta).subscribe((datos: any) => {
      if (datos && datos.tokenObj && datos.api) {
        setToken(datos.api, datos.tokenObj, this.storage);
      }

      if (datos.documents) {
        var cleanedDocuments = [];
        for (var i = 0; i < datos.documents.length; i++) {
          if (datos.documents[i] !== '') {
            cleanedDocuments.push(datos.documents[i]);
          }
        }

        this.documentos = { documents: cleanedDocuments };
        this.loadingData = false;

        if (cleanedDocuments.length === 1) {
          this.modelo['file-' + cleanedDocuments[0].documentId] = true;
          this.modelo['file-data'] = true;
          this.checkedDocuments = true;
          setTimeout(() => {
            this.obtenerInfo();
          }, 100);
        } else {
          this.showDocumentList = true;
          this.checkedDocuments = false;
        }
      }
    });
  }

  /*
    BANNERS.
  */

  // Obtener banners por referencia de orden.
  private getBanners(refOrder: any): void {
    obtainApi(this.qwebprinterService, this.url, this.toastService).then((api) => {
      obtainTokenAndCompanyParamsSigner(api, this.storage, this.qwebprinterService, this.toastService, this.apiServerService, this.url, this.idCliente).then(
        (serviceParams: any) => {
          this.getBannersQIS(serviceParams['token'], serviceParams['companyParams'], refOrder);
        }
      );
    });
  }

  // Obtener banners.
  private getBannersQIS(token: any, apiServer: any, refOrder: any): void {
    // Crear objeto de consulta.
    let objConsulta = {
      banner: {
        refOrder: refOrder,
      },
      companyParams: apiServer,
      token: token,
    };
    this.qwebprinterService.getBanners(this.url, objConsulta).subscribe((callback: any) => {
      // Si existen banners setear el token.
      if (callback && callback.tokenObj && callback.api) {
        setToken(callback.api, callback.tokenObj, this.storage);
      }
      // Cargar banners si existen.
      if (callback.urls) {
        // Cambiar bandera.
        this.hasBanners = true;
        // Obtener la lista de banners.
        this.bannerList = callback.urls;
      }
    });
  }

  /*
    PARA LOS PDFS.
  */

  // Obtener nombre de los documentos y las firmas.
  public obtenerInfo(): void {
    this.totalDocuments = this.documentos['documents'].length;
    this.hideElements = false;
    this.blockBody = false;
    this.loadingDataWebPrinter = true;
    this.ids = [];
    // Obtener lista de nombres de los documentos.
    this.ids = Object.keys(this.modelo);
    // Comprobar si esta vacio.
    if (this.ids && this.ids.length && this.ids.length <= 2) {
      // Si esta vacio deshabilitar el boton de siguiente documento.
      this.showNextButton = false;
    }
    // Quitar el nombre "file-data" de la lista de nombres de ficheros.
    if (this.ids && this.ids.length && this.ids.length > 1) {
      for (let i = 0; i < this.ids.length; i++) {
        if (this.ids[i].indexOf('file-data') >= 0) {
          this.ids.splice(i, 1);
        }
      }
      this.totalDocuments = this.ids.length;
      // Obtener firmas.
      this.obtainSigns(false, true, this.sp['token'], this.sp['companyParams']);
    }
  }

  // Obtener firmas.
  private async obtainSigns(downloadDocument: boolean, downloadSing: boolean, token: any, apiServer: any): Promise<void> {
    if (downloadDocument === true) {
      this.loadingDocument = true;
    }
    if (downloadDocument === false) {
      this.loadingData = true;
    }
    this.showDocumentList = false;
    // Limpiar la lista de firmas.
    this.idsSignature = [];
    // Obtener el id del documento del que se quieren cojer las firmas.
    this.idDocumento = this.ids[this.currentDocument].replace('file-', '');
    // Preparar opciones para la consulta acerca del documento que se necesita.
    let obj: any = {};
    obj['documento'] = {};
    obj['token'] = token;
    obj['companyParams'] = apiServer;
    // Si es necesario se descarga el documento pdf.
    if (downloadDocument === true) {
      await this.getUniqueDocument(this.idDocumento, 'false', obj);
    }
    // Recorrer todos los documnetos.
    for (let j = 0; j < this.documentos.documents.length; j++) {
      // Comprobar si el el documento quie se busca.
      if (this.documentos.documents[j] && this.documentos.documents[j].documentId === this.idDocumento) {
        // Preparar parametro "authorizationId".
        if (this.documentos.documents[j].authorizationId) {
          obj['documento']['authorizationId'] = this.documentos.documents[j].authorizationId;
        } else {
          // this.noSigns = true;
        }
        // Preparar parametro "signatureId".
        if (this.documentos.documents[j].signatureId) {
          obj['documento']['signatureId'] = this.documentos.documents[j].signatureId;
        } else {
          // this.noAuths = true;
        }
        // Preparar parametro "category".
        if (this.category) {
          obj['documento']['category'] = this.category;
        } else {
          obj['documento']['category'] = 1;
        }
        this.loopNum = j;
      }
    }
    // Obtener firmas y autorizaciones.
    if ((obj && obj['documento']['authorizationId']) || obj['documento']['signatureId']) {
      // Realizar llamada para obtener las firmas y las autorizaciones.
      this.qsignerService.getSigns(this.url, obj).subscribe((datos: any) => {
        // Setear token.
        if (datos && datos.tokenObj && datos.api) {
          setToken(datos.api, datos.tokenObj, this.storage);
        }
        // Limpiar objeto documents
        this.documents = {};
        this.documents = this.documentos.documents[this.loopNum];
        // Añadir firmas.
        if (datos && datos['signatures']) {
          this.documents['signatures'] = datos['signatures'];
        }
        // Añadir autorizaciones.
        if (datos && datos['authorization']) {
          this.documents['authorization'] = datos['authorization'];
        }
        // Añadir la propiedad de visible a las firmas.
        if (this.documents && this.documents.signatures && this.documents.signatures.length > 0) {
          for (let i = 0; i < this.documents.signatures.length; i++) {
            this.documents.signatures[i]['visible'] = true;
          }
        }

        // Añadir la propiedad de visible a los componentes.
        if (this.documents && this.documents.authorization && this.documents.authorization.length) {
          for (let i = 0; i < this.documents.authorization.length; i++) {
            this.documents.authorization[i]['visible'] = true;
          }
        }

        // Obtener campos
        if (this.documents && this.documents.authorization && this.documents.authorization.length) {
          for (let i = 0; i < this.documents.authorization.length; i++) {
            if (this.documents.authorization[i] && this.documents.authorization[i].fixedValue && this.documents.authorization[i].fixedValue.indexOf('~') >= 0) {
              if (this.documents && this.documents.authorization[i] && this.documents.authorization[i].fixedValue && this.documents.authorization[i].fixedValue.indexOf('~') >= 0) {
                var camposSplit = this.documents.authorization[i].fixedValue.split('~');
                this.documents.authorization[i].fixedValue = camposSplit;
              }
            }
          }
        }
        // Pdf.
        if (this.documents && this.documents.document) {
          this.page = 1;
          this.pdfSrc = 'data:application/pdf;base64,' + this.documents.document;
          this.hasDocument = true;
        } else {
          this.hasDocument = false;
        }
        this.loadingDataWebPrinter = false;
        this.showDocumentList = false;
        // Deshabilitar loading.
        if (downloadDocument === true) {
          this.loadingDocument = false;
        }
        if (downloadDocument === false) {
          this.loadingData = false;
        }

        // Cargar documento si no existe
        if (!this.hasDocument) {
          this.loadDocument(token, apiServer);
        }

        /**
         * MEJORA: Flujo optimizado para un solo documento sin firmas ni autorizaciones.
         *
         * Si se detecta que es un documento único sin necesidad de firmas:
         * 1. Mantiene el loading activo durante el procesamiento
         * 2. Envía los datos al DMS para registro
         * 3. Prepara el documento para visualización usando el contenido ya cargado
         * 4. Salta directamente a la pantalla de descarga
         * 5. Inicia la descarga automáticamente después de 500ms
         *
         * Este flujo reduce de 3 pantallas + 3 peticiones a 1 pantalla + 2 peticiones.
         */
        if (this.shouldSkipSignatureScreen() && this.totalDocuments === 1) {
          // Mantener el loading activo mientras se procesa
          this.loadingData = true;

          // Enviar datos al DMS aunque no haya firmas (para registro)
          this.sendDocumentData().then(() => {
            // Preparar documento para descarga
            this.documentos.documents.forEach((doc: any) => {
              if (this.modelo['file-' + doc['documentId']]) {
                this.documentosToDownload.push(doc);
                // Establecer el elemento a imprimir
                this.elementToPrint = doc['documentId'];

                // Usar el documento que ya se obtuvo en la primera llamada
                if (doc.document) {
                  this.documentToPrint = {
                    document: doc.document,
                    description: doc.description,
                  };
                  // Establecer el PDF para visualización
                  this.page = 1;
                  this.pdfSrc = 'data:application/pdf;base64,' + doc.document;
                  this.hasDocument = true;
                  this.showDocumentPdf = true;
                }
              }
            });

            // Ir directamente a la pantalla de descarga sin hacer otra petición
            this.loadingData = false;
            this.loadingDocument = false;
            this.showDocumentList = false;
            this.hasBanners = false;
            this.showData = false;
            this.showDownloadScreen = true;

            // Descargar automáticamente después de un breve delay
            setTimeout(() => {
              this.downloadSingDocument(null);
            }, 500);
          });
        } else {
          // Mostrar pantalla de firmas normalmente
          this.showData = true;
        }
      });
    } else {
      // Caso sin firmas ni autorizaciones
      this.documents = { entidad: 1 };
      if (this.documentos.documents[this.loopNum].document) {
        this.pdfSrc = 'data:application/pdf;base64,' + this.documentos.documents[this.loopNum].document;
        this.hasDocument = true;
      } else {
        this.hasDocument = false;
      }
      this.loadingDataWebPrinter = false;
      this.showDocumentList = false;
      this.blockBody = true;

      if (this.ids && this.ids.length && this.ids.length > 1) {
        this.showNextButton = true;
      } else {
        this.documents = {};
        this.model = {};
        this.document = {};
        this.idsButtons = [];
        this.showNextButton = false;
      }
      // Deshabilitar loading.
      if (downloadDocument === true) {
        this.loadingDocument = false;
      }
      if (downloadDocument === false) {
        this.loadingData = false;
      }

      // Cargar documento si no existe
      if (!this.hasDocument) {
        this.loadDocument(token, apiServer);
      }

      // Mostrar pantalla según el flujo
      if (this.shouldSkipSignatureScreen() && this.totalDocuments === 1) {
        // Flujo optimizado para documento sin firmas
        this.loadingData = true;

        this.sendDocumentData().then(() => {
          this.documentos.documents.forEach((doc: any) => {
            if (this.modelo['file-' + doc['documentId']]) {
              this.documentosToDownload.push(doc);
              this.elementToPrint = doc['documentId'];

              if (doc.document) {
                this.documentToPrint = {
                  document: doc.document,
                  description: doc.description,
                };
                this.page = 1;
                this.pdfSrc = 'data:application/pdf;base64,' + doc.document;
                this.hasDocument = true;
                this.showDocumentPdf = true;
              }
            }
          });

          this.loadingData = false;
          this.loadingDocument = false;
          this.showDocumentList = false;
          this.hasBanners = false;
          this.showData = false;
          this.showDownloadScreen = true;

          setTimeout(() => {
            this.downloadSingDocument(null);
          }, 500);
        });
      } else {
        // Mostrar pantalla de firmas normalmente
        this.showData = true;
      }
    }
  }

  public async loadDocument(token: any, apiServer: any): Promise<void> {
    // Obtener el id del documento.
    this.idDocumento = this.ids[this.currentDocument].replace('file-', '');
    // Preparar opciones para la consulta acerca del documento que se necesita.
    let obj: any = {};
    obj['documento'] = {};
    obj['token'] = token;
    obj['companyParams'] = apiServer;
    // Si es necesario se descarga el documento pdf.
    await this.getUniqueDocument(this.idDocumento, 'false', obj);

    this.documents = this.documentos.documents[this.loopNum];

    // Pdf.
    if (this.documents && this.documents.document) {
      this.page = 1;
      this.pdfSrc = 'data:application/pdf;base64,' + this.documents.document;
      this.hasDocument = true;
    } else {
      this.hasDocument = false;
    }
  }

  // Obtener documento pdf.
  private getUniqueDocument(idDocument: any, returnDocument: string, companyParams: any): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.id && idDocument && companyParams) {
        let objConsulta = {
          documento: {
            reference: this.id,
            returnDocument: returnDocument,
            event: this.event,
            documentId: idDocument,
          },
          companyParams: companyParams['companyParams'],
          token: companyParams['token'],
        };
        this.qwebprinterService.getDocuments(this.url, objConsulta).subscribe((datos: any) => {
          if (datos && datos['documents'] && datos['documents'].length && this.documentos && this.documentos.documents && this.documentos.documents.length) {
            for (let i = 0; i < this.documentos.documents.length; i++) {
              if (this.documentos.documents[i].documentId == datos['documents'][0].documentId) {
                this.documentos.documents[i].document = datos['documents'][0].document;
                this.showDocumentPdf = true;
                resolve();
              }
            }
          } else {
            reject();
            this.notDownloadDocument = true;
            showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', this.error_get_document_label);
          }
        });
      } else {
        reject();
      }
    });
  }

  /**
   * Previsualiza un documento en la pantalla de descarga mediante un modal.
   *
   * Este método:
   * 1. Obtiene el documento del servidor si aún no está cargado
   * 2. Prepara el visor PDF con el contenido
   * 3. Abre el modal solo cuando el documento está completamente cargado
   * 4. Actualiza el visor PDF y ajusta el tamaño
   *
   * Durante la carga, muestra un indicador de loading en el botón de previsualización.
   *
   * @async
   * @returns Promise que se resuelve cuando la previsualización está lista
   * @public
   */
  public async previewDocumentDownload(): Promise<void> {
    if (!this.elementToPrint) {
      return;
    }

    this.loadingDocument = true;

    let objConsulta = {
      documento: {
        reference: this.id,
        returnDocument: 'true',
        event: this.event,
        documentId: this.elementToPrint,
        isRequestDownload: 'false',
      },
      companyParams: this.sp['companyParams'],
      token: this.sp['token'],
    };

    this.qwebprinterService.getDocuments(this.url, objConsulta).subscribe((datos: any) => {
      if (datos && datos['documents'] && datos['documents'].length) {
        this.documentToPrint = {
          document: datos['documents'][0]['document'],
          description: datos['documents'][0]['description'],
        };
        // Establecer el PDF para visualización
        this.page = 1;
        this.pdfSrc = 'data:application/pdf;base64,' + this.documentToPrint.document;
        this.hasDocument = true;
        this.showDocumentPdf = true;
        this.loadingDocument = false;

        // Abrir el modal después de que el documento esté cargado
        setTimeout(() => {
          const modalElement = document.getElementById('previewDownloadModal');
          if (modalElement) {
            (window as any).$('#previewDownloadModal').modal('show');
          }

          // Actualizar el visor después de abrir el modal
          setTimeout(() => {
            if (this.pdfViewer) {
              this.pdfViewer.src = this.pdfSrc;
              window.dispatchEvent(new Event('resize'));
            }
          }, 300);
        }, 100);
      } else {
        this.loadingDocument = false;
        this.hasDocument = false;
      }
    });
  }

  /**
   * Descarga el documento firmado o procesado.
   *
   * OPTIMIZACIÓN: Para el caso de un solo documento sin firmas, reutiliza el documento
   * que ya está cargado en memoria (this.documentToPrint) evitando una petición HTTP adicional.
   *
   * Para otros casos (múltiples documentos o con firmas), realiza la petición normal
   * al servidor con isRequestDownload: 'true'.
   *
   * El documento se descarga automáticamente según el navegador del usuario.
   *
   * @param event - Evento del click (puede ser null en descarga automática)
   * @returns Promise que se resuelve cuando la descarga se completa
   * @public
   */
  public downloadSingDocument(event: any) {
    return new Promise<void>((resolve, reject) => {
      this.loadingDownloadSingDocument = true;

      // OPTIMIZACIÓN: Si ya tenemos el documento cargado Y es un único documento, usarlo directamente
      // Para múltiples documentos, siempre hacer la petición del documento seleccionado
      if (this.documentToPrint && this.documentToPrint.document && this.totalDocuments === 1) {
        // Usar el documento que ya tenemos cargado (solo para documento único)
        this.downloadOneDocument()
          .then(() => {
            this.loadingDownloadSingDocument = false;
            resolve();
          })
          .catch(() => {
            this.loadingDownloadSingDocument = false;
            reject();
          });
        return;
      }

      // Para múltiples documentos o cuando no está cargado, hacer la petición
      let objConsulta = {
        documento: {
          reference: this.id,
          returnDocument: 'true',
          event: this.event,
          documentId: this.elementToPrint,
          isRequestDownload: 'true', // obligatorio true
        },
        companyParams: this.sp['companyParams'],
        token: this.sp['token'],
      };
      this.qwebprinterService.getDocuments(this.url, objConsulta).subscribe(async (datos: any) => {
        if (datos && datos['documents'] && datos['documents'].length && this.documentos && this.documentos.documents && this.documentos.documents.length) {
          this.documentToPrint = {
            document: datos['documents'][0]['document'],
            description: datos['documents'][0]['description'],
          };
          await this.downloadOneDocument();
          this.loadingDownloadSingDocument = false;
          resolve();
        } else {
          this.loadingDownloadSingDocument = false;
          reject();
        }
      });
    });
  }

  // Descargar un documento.
  public downloadOneDocument() {
    return new Promise<void>((resolve, reject) => {
      try {
        var byteCharacters = atob(this.documentToPrint.document.replace(/\s/g, ''));
        const byteNumbers = new Array(byteCharacters.length);
        for (let j = 0; j < byteCharacters.length; j++) {
          byteNumbers[j] = byteCharacters.charCodeAt(j);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: 'application/pdf',
        });
        const blobUrl = URL.createObjectURL(blob);
        var file = {
          filename: 'Impreso',
          base64: this.documentToPrint.document,
          type: 'pdf',
        };
        if (this.nativo == true) {
          this.oLangWebViewInterface.emit('downloadFile', file['base64']);
          resolve();
        } else {
          var is_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
          if (is_uiwebview == true) {
            try {
              var link = document.createElement('a');
              link.href = blobUrl;
              link.download = this.documentToPrint['description'];
              link.dispatchEvent(new MouseEvent('click'));
              resolve();
            } catch (e) {
              reject();
            }
          } else {
            window.open(blobUrl.toString(), '_blank');
            resolve();
          }
        }
      } catch (e) {
        reject();
      }
    });
  }

  // Cargar documento firmado para visualización y descarga
  public loadSignedDocumentForDownload(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.elementToPrint) {
        reject('No document to print');
        return;
      }

      let objConsulta = {
        documento: {
          reference: this.id,
          returnDocument: 'true',
          event: this.event,
          documentId: this.elementToPrint,
          isRequestDownload: 'true',
        },
        companyParams: this.sp['companyParams'],
        token: this.sp['token'],
      };

      this.qwebprinterService.getDocuments(this.url, objConsulta).subscribe(
        (datos: any) => {
          if (datos && datos['documents'] && datos['documents'].length > 0) {
            this.documentToPrint = {
              document: datos['documents'][0]['document'],
              description: datos['documents'][0]['description'],
            };
            // Configurar PDF para visualización
            this.page = 1;
            this.pdfSrc = 'data:application/pdf;base64,' + datos['documents'][0]['document'];
            this.hasDocument = true;
            this.showDocumentPdf = true;
            resolve();
          } else {
            reject('No document found');
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  public afterLoadComplete(pdfData: any): void {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  /*
    BARRA DE NAVEGACIÓN INFERIOR.
  */

  /**
   * Verifica si se debe saltar la pantalla de firmas.
   *
   * Determina si el documento actual no tiene firmas ni autorizaciones, lo que
   * permite omitir la pantalla de firma y optimizar el flujo del usuario.
   *
   * @returns true si no hay firmas ni autorizaciones, false en caso contrario
   * @private
   */
  private shouldSkipSignatureScreen(): boolean {
    return (!this.documents?.signatures || this.documents.signatures.length === 0) && (!this.documents?.authorization || this.documents.authorization.length === 0);
  }

  // Botón avanzar para cambiar de documento.
  public async changeDocument(): Promise<void> {
    let isRequired = this.isRequiredFields();
    // Comprobar los campos requeridos.
    if (isRequired) {
      // Posicionarse en la parte superior de la pantalla.
      scrollToTop();
      // Actualizar el número de documento que se quiere mostrar.
      let total = this.totalDocuments - 1;
      // Controlar si la siguiente es la última.
      if (this.currentDocument < total) {
        // Enviar firmas al DMS.
        await this.sendDocumentData();
        this.currentDocument = this.currentDocument + 1;
        this.hasDocument = false;
        this.obtenerInfo();
      } else {
        // Enviar firmas al DMS.
        await this.sendDocumentData();
        // Si es la última pantalla ocultar el resto.
        this.documentos.documents.forEach((doc: any) => {
          if (this.modelo['file-' + doc['documentId']]) {
            this.documentosToDownload.push(doc);
            this.elementToPrint = doc['documentId'];
          }
        });

        // Para el caso de un único documento con firmas, cargar el documento antes de mostrar la pantalla
        if (this.totalDocuments === 1 && this.documentosToDownload.length === 1) {
          // Mantener el loading activo mientras se carga el documento
          this.loadingData = true;

          // Obtener el documento firmado para visualización y descarga
          await this.loadSignedDocumentForDownload();

          // Ahora sí mostrar la pantalla con todo listo
          this.loadingData = false;
          this.loadingDocument = false;
          this.showDocumentList = false;
          this.hasBanners = false;
          this.showData = false;
          this.showDownloadScreen = true;

          // Descargar automáticamente después de un breve delay
          setTimeout(() => {
            this.downloadSingDocument(null);
          }, 500);
        } else {
          // Para múltiples documentos, mostrar la pantalla normalmente
          this.loadingData = false;
          this.loadingDocument = false;
          this.showDocumentList = false;
          this.hasBanners = false;
          this.showData = false;
          this.showDownloadScreen = true;
        }
      }
    } else {
      if (this.typeRequiredError === 'Empty') {
        showToaster(this.toastService, 'warning', this.translateService, 'COMMON.WARNING', this.require_fields_label);
      } else {
        showToaster(this.toastService, 'warning', this.translateService, 'COMMON.WARNING', this.require_require_max_size_sing_label);
      }

      this.typeRequiredError = '';
    }
  }

  // Enviar documento cada vez que se firme.
  public sendDocumentData(): Promise<void> {
    return new Promise((resolve: any, reject: any) => {
      this.loadingSendDocuments = true;
      // Crear objeto
      let obj: any = {};
      obj['token'] = this.sp['token'];
      obj['companyParams'] = this.sp['companyParams'];
      // Crear id del docuimento.
      let doc: string = this.idDocumento + '*' + this.id + '*gateway*' + this.documents.eventId;
      obj['respuesta'] = {};
      obj['respuesta']['documentId'] = doc;
      // otros datos:
      obj['respuesta']['headText'] = 'string';
      obj['respuesta']['deviceId'] = 'string';
      obj['respuesta']['category'] = 1;
      obj['respuesta']['isGenerateDocument'] = true;
      obj['respuesta']['isRemote'] = false;
      // Autorizaciones.
      if (this.documents && this.documents['authorizationId']) {
        obj['respuesta']['authorizationId'] = this.documents['authorizationId'];
      }
      // Autorizaciones contenido.
      if (this.documents['authorization']) {
        let auths: any[] = [];
        this.documents['authorization'].forEach((e: any) => {
          let auth = {
            authorizationId: e['authorizationId'],
            authorizationResult: this.model[e['authorizationId']],
          };
          auths.push(auth);
        });
        obj['respuesta']['authorization'] = auths;
      }
      // firmas.
      obj['respuesta']['signatureId'] = ''; // FALTA
      // Firmas contenido.
      if (this.firmas && this.firmas.toArray() && this.firmas.toArray().length > 0) {
        let sings: any[] = [];
        this.firmas.toArray().forEach((e: any) => {
          const id = e['element']['id'].split('_');
          let sing = {
            signatureId: id[1],
            signature: this.cleanBase64Img(e.getSignature()),
          };
          sings.push(sing);
        });
        obj['respuesta']['signatures'] = sings;
      }
      this.qsignerService.postSignature(this.url, obj).subscribe({
        next: (res: any) => {
          if (res && res['code'] && res['code'] === 'dms_error') {
            showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', res['message']);
          } else {
            showToaster(this.toastService, 'success', this.translateService, 'COMMON.SUCCESS', this.send_data_label);
          }
          this.loadingSendDocuments = false;
          resolve();
        },
        error: (error) => {
          this.loadingSendDocuments = false;
          reject();
        },
      });
    });
  }

  // Función para el botón de mostrar los documentos Pdf.
  public async showDocuments(): Promise<void> {
    if (!this.hasDocument) {
      this.loadingDocument = true;

      // Obtener el id del documento del que se quieren cojer las firmas.
      this.idDocumento = this.ids[this.currentDocument].replace('file-', '');
      // Preparar opciones para la consulta acerca del documento que se necesita.
      let obj: any = {};
      obj['documento'] = {};
      obj['token'] = this.sp['token'];
      obj['companyParams'] = this.sp['companyParams'];
      obj['documento']['eventId'] = 11;
      obj['documento']['reference'] = this.id;
      // Si es necesario se descarga el documento pdf.

      await this.getUniqueDocument(this.idDocumento, 'true', obj);
      // Pdf.
      if (this.documents && this.documents.document) {
        this.page = 1;
        this.pdfSrc = 'data:application/pdf;base64,' + this.documents.document;
        this.hasDocument = true;
        this.showDocumentPdf = true;
      } else {
        this.hasDocument = false;
      }
      this.loadingDocument = false;
    }

    // Posicionarse en la parte superior de la página.
    scrollToTop();

    setTimeout(() => {
      // this.pdfViewer.
      this.pdfViewer.src = this.pdfSrc;
    }, 500);
  }

  // Comprobar si es requerido.
  private isRequiredFields(): boolean {
    let f = this.firmas.toArray();
    let result: boolean = true;
    // Comprobar firmas.
    this.documents?.['signatures']?.forEach((e: any) => {
      if (e['required'] && e['signatureId']) {
        f.forEach((x: any) => {
          let id = x['element'] && x['element']['id'] ? x['element']['id'].replace('sig-', '') : undefined;
          let xblob = x.saveAsBlob();
          if (id && e['signatureId'] === id && x.isEmpty()) {
            this.typeRequiredError = 'Empty';
            result = false;
          }
          if (id && e['signatureId'] === id && xblob.size < this.sizeSign && !x.isEmpty()) {
            this.typeRequiredError = 'Size';
            result = false;
          }
        });
      }
    });
    // Comprobar valores requeridos.
    if (this.documents.authorization) {
      this.documents.authorization.forEach((element: any) => {
        if (element.requiredAuthentication) {
          // Comprobar valores de los radio buttons (tipo 1).
          if (!element['value'] && element['authorizationType'] === 1) {
            this.typeRequiredError = 'Empty';
            result = false;
          }
          // Comprobar valores de los input de texto (tipo 2).
          if (element['authorizationType'] === 2 || element['authorizationType'] === 5 || element['authorizationType'] === 4) {
            let value = this.model[element['authorizationId']];
            if (!value) {
              this.typeRequiredError = 'Empty';
              result = false;
            }
          }
        }
      });
    }
    return result;
  }

  // Limpiar imagen en Base64.
  private cleanBase64Img(imgBase64: any): any {
    return imgBase64.substr(imgBase64.indexOf(',') + 1);
  }

  // Botón terminar, cerrar la pestaña del navegador.
  public close(): void {
    // @grant window.close
    setTimeout(() => {
      let w: any = window;
      if (window) {
        this.oLangWebViewInterface.emit('goBack', true);
        w.open('', '_self').close();
      }
    }, 500);
    setTimeout(window.close, 1000);
    window.close();
  }

  /*
    BARRA DE NAVEGACIÓN PARA LOS PDFs.
  */

  // Avanza página (hasta llegar a la última).
  public nextPage(): void {
    this.page++;
  }

  // Retrocede página (hasta llegar a la última).
  public prevPage(): void {
    this.page--;
  }

  // Aumentar zoom (hasta 3 niveles).
  public zoom_in(): void {
    this.zoom = this.zoom + 0.5;
  }

  // Disminuir zoom (hasta el nivel 1).
  public zoom_out(): void {
    this.zoom = this.zoom - 0.5;
  }

  // Imprimir un documento.
  public printDocument(event: any) {
    return new Promise<void>((resolve, reject) => {
      let byteCharacters;
      // Decode base64 string
      if (this.documentPrint !== undefined) {
        byteCharacters = atob(this.documentPrint.replace(/\s/g, ''));
      } else {
        byteCharacters = atob(this.documentos.documents[this.loopNum].document.replace(/\s/g, ''));
      }
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      const file = {
        filename: 'Impreso',
        base64: this.pdfSrc.split('data:application/pdf;base64,')[1],
        type: 'pdf',
      };
      if (this.nativo == true) {
        this.oLangWebViewInterface.emit('downloadFile', file['base64']);
        resolve();
      } else {
        const is_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
        if (is_uiwebview == false) {
          window.open(blobUrl.toString(), '_blank');
          resolve();
        } else {
          try {
            let link = document.createElement('a');
            link.href = blobUrl;
            link.download = file['filename'];
            link.dispatchEvent(new MouseEvent('click'));
            resolve();
          } catch (e) {
            reject();
          }
        }
      }
    });
  }
  /*
    PARA LAS FIRMAS.
  */

  // Borrar firma del componente por id.
  public clearSignatureComponentById(id: any): void {
    // Buscar el id de la firma que se quiere borrar.
    this.firmas.toArray().forEach((element) => {
      if (element && element['element'] && element['element']['id'] && element['element']['id'] === id) {
        // Borrar la firma.
        element.clear();
      }
    });
  }

  /*
    PARA LOS TAB DE LAS FIRMAS.
  */

  // Con cada click sobre un tab o document se ocultan todas las firmas y su botón de borrar asociado.
  public ocultarSignatures(event: any, ids: any) {
    this.documentos['documents'].forEach((e: any) => {
      if (e['signatures']) {
        e['signatures'].forEach((e2: any) => {
          if (e2['signatureId'] === ids) {
            e2['visible'] = e2['visible'] === false ? true : false;
          }
        });
      }
    });
  }

  // Evento para cuando se firma.
  public changeSignature(): void {
    this.firmas.toArray().forEach((e: any) => {
      let obj = {
        id: e['element']['id'],
        signature: this.cleanBase64Img(e.getSignature()),
      };
    });
  }

  /*
    PARA LOS CHECKBOX DE LA PANTALLA INICIAL.
  */

  // Añadir o eliminar del modelo los ficheros seleccionados.
  public changeSelectFiles(fileId: any): void {
    let element: any = document.querySelector('#' + fileId);
    this.elementToPrint = element.id.replace('file-', '');
    if (element['checked'] === false) {
      this.modelo[fileId] = undefined;
      delete this.modelo[fileId];
    }

    let anyCheckBox = Object.keys(this.modelo);
    let control = false;
    if (anyCheckBox && anyCheckBox.length > 0) {
      for (let i = 0; i < anyCheckBox.length; i++) {
        if (anyCheckBox[i].includes('file-') && !anyCheckBox[i].includes('file-data')) {
          this.modelo['file-data'] = true;
          control = true;
        }
      }
      if (control === false) {
        delete this.modelo['file-data'];
      }
    }

    // Check if documents have been checked
    if (Object.keys(this.modelo).length > 0) {
      this.checkedDocuments = true;
    } else {
      this.checkedDocuments = false;
    }
  }

  /*
    PARA EL TAB DE LAS AUTORIZACIONES.
  */

  // Con cada click sobre o document se ocultan todos los tabsets.
  public ocultarTabsetss(id: any): void {
    this.documents.authorization.forEach((c: any, i: number) => {
      if (c['authorizationId'] === id) {
        c['visible'] = c['visible'] === false ? true : false;
      }
    });
  }

  /*
    PARA LOS DESPLEGABLES DE LAS OPCIONES (PENDIENTE DE REVISAR).
  */

  // Si el checkbox no esta seleccionado, lo elimina del modelo.
  public changeCheckBox(value: any, id: any, ngmodel: any): void {
    // Obtener el elemento.
    var element: any = document.getElementById(id);
    // Eliminar si no esta marcado.
    if (element.checked === false) {
      this.model[id] = undefined;
      delete this.model[id];
    }
    let anyCheckBox = Object.keys(this.model);
    let control = false;
    if (anyCheckBox && anyCheckBox.length > 0) {
      for (let i = 0; i < anyCheckBox.length; i++) {
        if (anyCheckBox[i].includes('checkbox-') && !anyCheckBox[i].includes('checkbox-data')) {
          this.model['checkbox-data'] = true;
          control = true;
        }
      }
      if (control === false) {
        delete this.model['checkbox-data'];
      }
    }
  }

  /*
    PENDIENTE.
  */

  // Resetear autorizacion.
  public borrarAuthorization(id: any): void {
    let expresion = id.split('-')[0];
    let identifier = id.split('-')[1];
    let keys;
    switch (expresion) {
      case 'checkbox':
        let keysCheck = Object.keys(this.model);
        let keysCheckLength = keysCheck.length;
        if (keysCheck && keysCheck.length > 0) {
          for (let i = 0; i < keysCheckLength; i++) {
            let inputs: any = document.querySelectorAll('#' + id + ' input');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier && inputs[j].checked) {
                  inputs[j].checked = false;
                  delete this.model[inputs[j].id];
                }
              }
            }
          }
        }
        delete this.model['checkbox-data'];
        break;
      case 'radio':
        // Borrar autorizaciones.
        this.documents['authorization'].forEach((e: any) => {
          if (e['authorizationId'] === identifier) {
            e['value'] = undefined;
          }
        });
        keys = Object.keys(this.model);
        if (keys && keys.length > 0) {
          for (let i = 0; i < keys.length; i++) {
            let radio = id.split('-')[1].indexOf(keys[i]);
            let tabId = 'tab-' + keys[i];
            let tabElement: any = document.getElementById(tabId);
            let inputs = tabElement.getElementsByTagName('input');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier && inputs[j].checked) {
                  inputs[j].checked = false;
                  delete this.model[keys[i]];
                }
              }
            }
          }
        }
        break;
      case 'textarea':
        keys = Object.keys(this.model);
        if (keys && keys.length > 0) {
          for (let i = 0; i < keys.length; i++) {
            let radio = id.split('-')[1].indexOf(keys[i]);
            let tabElement: any = document.getElementById('tab-' + keys[i]);
            let inputs = tabElement.getElementsByTagName('textarea');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier) {
                  inputs[j].value = '';
                }
              }
              delete this.model[keys[i]];
            }
          }
        }
        break;
      default:
        let keysDatePicker = Object.keys(this.model);
        if (keysDatePicker && keysDatePicker.length > 0) {
          for (let i = 0; i < keysDatePicker.length; i++) {
            let datePicker = id.split('-')[1].indexOf(keysDatePicker[i]);
            if (datePicker >= 0) {
              this.model[keysDatePicker[i]] = 0;
              delete this.model[keysDatePicker[i]];
            }
          }
        }
        break;
    }
  }

  // Obtener valor de un radio button.
  public changeRadioButton(event: any, type: number): void {
    // Obtener valores.
    let id: string = event && event['currentTarget'] && event['currentTarget']['id'] ? event['currentTarget']['id'] : undefined;
    let valor: boolean = event && event['returnValue'] ? event['returnValue'] : undefined;
    // Añadir valor del radio button.
    if (id !== undefined && valor !== undefined) {
      this.documents.authorization.forEach((element: any) => {
        if (element['authorizationId'] == id && element['authorizationType'] === type) {
          element['value'] = valor;
        }
      });
    }
  }

  /*
    TRATAMIENTO DE LOS DATOS.
  */

  // Metodo para formatear todos los textos.
  public decodeHtmlEntities(str: any) {
    // Crear un elemento temporal para usar la función browser incorporada
    let tempElement = document.createElement('textarea');

    // Utilizar un regex para encontrar todas las entidades numéricas
    return str.replace(/&#(\d+);/g, (match: any, dec: any) => {
      // Establecer el valor de la entidad en el elemento temporal
      tempElement.innerHTML = `&#${dec};`;
      // Devolver el texto decodificado
      return tempElement.value;
    });
  }

  /**
   * Calcular tamaño del componente de firma.
   * @returns {void}
   */
  public setDynamicSize(): void {
    let signElement: any = this.documentDOM.querySelector('.signature-component');
    if (signElement) {
      let widthElement: number = signElement.width;
      if (widthElement > 800) {
        this.sizeSign = 5500;
      } else if (widthElement < 800 && widthElement > 600) {
        this.sizeSign = 4000;
      } else if (widthElement < 600 && widthElement > 500) {
        this.sizeSign = 3500;
      } else {
        this.sizeSign = 3000;
      }
    }
  }
}
